import React from 'react';

import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import App from "./App";
import UserProfileProvider from "./components/UserProfileProvider";  /* Need to override UserProfile */
import AppConfigProvider from "./framework/AppConfigProvider";
import webRootContext from "./components/webrootcontext/WebRootContext";


// link css files
import './index.css';
import "antd/dist/antd.css";

/*
 <UserProfileProvider webRootContext={webRootContext}>
  </UserProfileProvider>
*/

ReactDOM.render(
   
   <UserProfileProvider webRootContext={webRootContext}>
    	<AppConfigProvider >    
	  		<App/>	  		
	  	</AppConfigProvider>
 	</UserProfileProvider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
